import {
  IRequestConfig,
  IRequestOptions,
  ShApiResponse_GetCancelSubjectOrderDto,
  axios,
  basePath,
  getConfigs,
} from "./index.defs";

export class OrdersApiService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   * Cancel subject order
   */
  static ordersCancelSubjectOrder(
    params: {
      /**  */
      id: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetCancelSubjectOrderDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/orders/{id}";
      url = url.replace("{id}", params["id"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "delete",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
